export default {
  List: {},
  ConfigMethod: {
    DifferentSchool: {
      LocalCard: "Thẻ ATM nội địa (40 ngân hàng tại Việt Nam)",
      Visa: "Thẻ quốc tế phát hành tại Việt Nam (VISA, MasterCard, JCB)",
      QRCode: "Mobile banking (QR-code của 35 ngân hàng và 14 ví điện tử)",
      ViettelMoney: "Viettel Money (ViettelPay và Mobile Money)",
      TransferMoney: "Chuyển khoản (từ tài khoản của tất cả các Ngân hàng tại Việt Nam)",
      MoMo: "Ví điện tử/Điểm giao dịch của MoMo",
    },
    School: {
      LocalCard: "Thẻ ATM nội địa (40 ngân hàng tại Việt Nam)",
      Visa: "Thẻ quốc tế phát hành tại Việt Nam (VISA, MasterCard, JCB)",
      QRCode: "Mobile banking (QR-code của 35 ngân hàng và 14 ví điện tử)",
      ViettelMoney: "Viettel Money (ViettelPay và Mobile Money)",
      TransferMoney: "Chuyển khoản (từ tài khoản của tất cả các Ngân hàng tại Việt Nam)",
      ZaloPay: "Ví điện tử ZaloPay",
      BankAccount: "Thanh toán hóa đơn của Vietcombank & BIDV",
      MoMo: "Ví điện tử/Điểm giao dịch của MoMo",
      TuitionSacombank: "Thu hộ học phí trên các kênh của Sacombank",
      TuitionBIDV: "Thu hộ học phí trên các kênh của BIDV",
      TuitionVietcombank: "Thu hộ học phí trên các kênh của Vietcombank",
      TuitionAgribank: "Thu hộ học phí trên các kênh của Agribank",
      TuitionVTB: "Thu hộ học phí trên các kênh của Vietinbank",
    },
  },
  Button: {
    Edit: "Sửa",
    Save: "Lưu",
    Close: "Đóng",
  },
  Detail: {
    Add: "Thêm",
    Cancel: "Hủy bỏ",
    Save: "Lưu",
    Edit: "Sửa",
    BtnConfirmYes: "Đồng ý",
    BtnConfirmCancel: "Hủy bỏ",
    Error: "Có lỗi xảy ra. Vui lòng thử lại",
  },
};
